import { setup_ajax, show_login_prompt_if_required } from "./helpers";
setup_ajax();

function toggle_button_classes(elem) {
  elem.toggleClass("follow");
  elem.toggleClass("following");

  elem.toggleClass("text-white");
  elem.toggleClass("bg-gray-900");
  elem.toggleClass("hover:bg-gray-800");

  elem.toggleClass("border-gray-400");
  elem.toggleClass("hover:border-gray-500");
}

function trackUserFollowEvent(eventType, userId) {
  fetch("/api/analytics/track_event", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      event_type: eventType,
      source_surface: "user_follow_button",
      viewed_profile_id: parseInt(userId, 10) || null,
      target_url: window.location.pathname,
    }),
    keepalive: true,
  }).catch(function () {});
}

$(function () {
  $("body").on("click", ".following", function () {
    if (show_login_prompt_if_required("follow")) {
      return;
    }

    $(this).text("Follow");
    toggle_button_classes($(this));

    $.ajax({
      type: "DELETE",
      url: "/api/user/following",
      data: { user_id: $(this).data("user-id") },
      success: function (response) {
        trackUserFollowEvent("user_unfollow", $(this).data("user-id"));
      }.bind(this),
    });
  });
  $("body").on("click", ".follow", function () {
    if (show_login_prompt_if_required("follow")) {
      return;
    }

    $(this).text("Following");
    toggle_button_classes($(this));

    $.ajax({
      type: "POST",
      url: "/api/user/following",
      data: { user_id: $(this).data("user-id") },
      success: function (response) {
        trackUserFollowEvent("user_follow", $(this).data("user-id"));
      }.bind(this),
    });
  });
});
